var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "historial-pagos-container" } }, [
    _c(
      "div",
      { staticClass: "card-item" },
      [
        _c("TransactionsHistory", {
          attrs: {
            id: "transactions-history",
            "client-id": _vm.clientId,
            "current-user-is-client": !!_vm.clientId,
            "payment-providers": _vm.paymentProviders,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }